import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { getProducts } from "../lib/api";
import { ProductCard } from "./ProductCard";

export default function Shop() {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    getProducts().then(setProducts).catch(() => {});
  }, []);

  const featured = products.filter((p) => p.featured);

  return (
    <section id="shop" className="relative py-24 sm:py-32" data-testid="shop-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <p className="overline text-blaze mb-4">Motivation Unlocked merch</p>
            <h2 className="font-heading font-800 tracking-tight text-4xl sm:text-5xl leading-tight">
              Wear the reminder. Carry the mindset.
            </h2>
            <p className="mt-6 text-white/70 leading-relaxed">
              Clean, intentional pieces built around discipline, purpose, and growth. Every drop
              carries the message — some the emblem, some a mantra, some both.
            </p>
          </div>
          <Link
            to="/merch"
            className="inline-flex items-center gap-2 rounded-full border border-white/20 px-5 py-3 text-sm font-bold hover:bg-white/10 transition-colors whitespace-nowrap"
            data-testid="shop-see-more"
          >
            See full store <ArrowRight size={16} />
          </Link>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featured.map((p, i) => (
            <ProductCard key={p.id} product={p} index={i} />
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/merch"
            className="inline-flex items-center gap-2 rounded-full bg-blaze px-6 py-3.5 text-sm font-bold text-white transition-transform hover:scale-105 hover:blaze-glow"
            data-testid="shop-see-more-bottom"
          >
            Explore all {products.length} products <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
}
